<po-page-default [p-title]="page.title" [p-breadcrumb]="page.breadcrumb" [p-actions]="page.actions">

  <po-divider class="po-md-12" [p-label]="informacoesFornecedor"></po-divider>

  <!-- 
        Este `ng-template` é usado para o stepper em caso de inclusão de notas.
        Ele está com código duplicado, então atualize seu código caso modifique
        o html para as paginas de visualização e edição.
     -->
  <ng-template [ngIf]="isAddPage">
    <po-stepper #preNotaStepper class="pre-nota-stepper">
      <po-step p-label="Incluir Nota Fiscal" [p-can-active-next-step]="stepper.isSent">
        <!-- <div class="po-row"> -->
        <div *ngFor="let d of arrHeaders">
          <po-input
            *ngIf="d.type == 'C' && !d.select && !d.f3 && d.property != 'F1_XREJEIC' && d.property != 'F1_DOC' && d.property != 'F1_SERIE'"
            class="po-md-3" p-label="{{d.label}}" [p-disabled]="disabledField" p-maxlength="{{d.tamanho}}"
            p-required="{{d.required}}" p-disabled="{{d.readonly}}" [(ngModel)]="dados[d.property]"
            p-mask="{{d.format}}"></po-input>

          <po-number *ngIf="d.property == 'F1_DOC'" class="po-md-3" p-min="1" p-max="999999999"
            p-label="Numero da sua Nota fiscal" [p-disabled]="disabledField" p-maxlength="{{d.tamanho}}"
            p-required="{{d.required}}" p-readonly="{{d.readonly}}" [(ngModel)]="dados[d.property]"></po-number>

          <po-select *ngIf="d.select   && d.property != 'F1_SERIE'" class="po-md-3" p-label="{{d.label}}"
            [p-disabled]="disabledFieldEdit" p-required="{{d.required}}" p-readonly="{{d.readonly}}"
            [p-options]="d.options" [(ngModel)]="dados[d.property]"></po-select>

          <po-select *ngIf="d.property == 'F1_SERIE'" class="po-md-3" p-label="{{d.label}}"
            [p-disabled]="disabledFieldEdit" p-required="{{d.required}}" p-readonly="{{d.readonly}}"
            [p-options]="d.options" [(ngModel)]="dados[d.property]" (click)="abrirMensagemGov()"></po-select>

          <po-datepicker *ngIf="d.type == 'D'" class="po-md-3" p-label="{{d.label}}" [p-disabled]="disabledFieldEdit"
            p-required="{{d.required}}" p-readonly="{{d.readonly}}" [(ngModel)]="dados[d.property]"></po-datepicker>
          <po-number *ngIf="d.type == 'N'" class="po-md-3" p-label="{{d.label}}" [p-disabled]="disabledFieldEdit"
            p-required="{{d.required}}" p-readonly="{{d.readonly}}" [(ngModel)]="dados[d.property]"></po-number>
          <po-textarea *ngIf="d.type == 'M'" class="po-md-3" p-label="{{d.label}}" [p-disabled]="disabledFieldEdit"
            p-required="{{d.required}}" p-readonly="{{d.readonly}}" [(ngModel)]="dados[d.property]"></po-textarea>

          <po-combo *ngIf="d.f3 && d.tabela == '42'" class="po-md-3" p-label="{{d.label}}"
            [p-disabled]="disabledFieldEdit" [p-options]="selects.especieDocumento" p-required="{{d.required}}"
            [(ngModel)]="dados[d.property]" p-filter-mode="contains"
            (p-change)="verificaAlteracaoEspecieDocumento($event,dados)"></po-combo>

          <!-- <div class="po-md-12 po-row"> -->
          <po-input *ngIf="d.property == 'F1_COND'" class="po-md-3" p-label="{{d.label}}" p-disabled="true"
            p-maxlength="{{d.tamanho}}" p-required="{{d.required}}" p-readonly="{{d.readonly}}"
            [(ngModel)]="dados[d.property]" p-mask="{{d.format}}"></po-input>
          <po-input *ngIf="d.property == 'F1_XREJEIC'" class="po-md-9" p-label="{{d.label}}" p-disabled="true"
            p-maxlength="{{d.tamanho}}" p-required="{{d.required}}" p-readonly="{{d.readonly}}"
            [(ngModel)]="dados[d.property]" p-mask="{{d.format}}"></po-input>
          <!-- </div> -->
        </div>
        <!-- </div> -->

        <!-- *ngIf="arrHeaders.length <= 0" -->
        <po-divider class="po-md-12" p-label="Itens da Nota Fiscal"></po-divider>

        <table class="table text-center po-table-main-container po-table">
          <thead>
            <tr>
              <th class="po-table-header">Item </th>
              <th class="po-table-header">Código</th>
              <th class="po-table-header">Quantidade</th>
              <th class="po-table-header">Valor Unitário</th>
              <th class="po-table-header">Valor Total</th>
              <th class="po-table-header">Pedido</th>
              <th class="po-table-header">Item Pedido </th>
              <th class="po-table-header">Histórico</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of tableItens" class="altura-linha">
              <td style="font-weight: bold;" class="po-table-column po-table-striped">
                <po-info class="po-lg-12" [p-value]="item.D1_ITEM"></po-info>
              </td>
              <td class="po-table-column po-table-striped">
                <po-info style="font-weight: bold;" class="po-lg-12" [p-value]="item.D1_COD"> </po-info>
              </td>
              <td class="po-table-column po-table-striped">
                <po-decimal [p-disabled]="disabledField" class="po-lg-12" p-clean="true"
                  (p-change)="calculaPrecoAplicado(item)" [(ngModel)]="item.D1_QUANT"></po-decimal>
              </td>
              <td class="po-table-column po-table-striped">
                <po-decimal class="po-lg-12" p-disabled="true" p-decimals-length="2"
                  [(ngModel)]="item.D1_VUNIT"></po-decimal>
              </td>
              <td class="po-table-column po-table-striped">
                <po-decimal class="po-lg-12" p-disabled="true" p-decimals-length="2"
                  [(ngModel)]="item.D1_TOTAL"></po-decimal>
              </td>
              <td class="po-table-column po-table-striped">
                <po-input class="po-lg-12" p-disabled="true" [(ngModel)]="item.D1_PEDIDO"></po-input>
              </td>

              <td class="po-table-column po-table-striped">
                <po-input class="po-lg-12" p-disabled="true" [(ngModel)]="item.D1_ITEMPC"></po-input>
              </td>
              <td class="po-table-column po-table-striped">
                <po-textarea p-disabled="true" [(ngModel)]='item.D1_XHISTOR'> </po-textarea>
              </td>
            </tr>
          </tbody>
        </table>
      </po-step>
      <po-step p-label="Anexar documento" [p-can-active-next-step]="stepper.isUploaded">
        <div class="po-row">
          <h3 class="mensagem-alerta mensagem-centralizada">É obrigatório anexar Nota fiscal em PDF</h3>
        </div>

        <div class="po-row">
          <po-upload #upload class="po-md-4 po-mt-4 po-offset-xl-4" [p-url]="uploadURL" (p-error)="uploadError($event)"
            [p-restrictions]="fileRestrictions" (p-upload)="anexaArquivo($event)" (p-success)="uploadSuccess($event)">
          </po-upload>
        </div>
        <div class="po-row">
          <po-button class="po-md-4 po-mt-3 po-offset-xl-4" p-icon="po-icon po-icon-eye-off" p-label="Exibir Arquivos"
            (click)="exibeFiles()"></po-button>
        </div>

        <div class="po-row">
          <po-button class="po-md-4 po-mt-3 po-offset-xl-4" *ngIf="item.length > 0" p-icon="po-icon po-icon-download"
            p-label="Baixar arquivo (s) selecionado (s)" (click)="downloadFiles()"></po-button>
        </div>

        <po-table *ngIf="mostrarArquivos" [p-columns]="tableConhecimento.columns" [p-items]="tableConhecimento.items"
          p-sort="true" p-striped="true" p-selectable="true" (p-selected)="tableConhecimento.select($event)"
          (p-unselected)="tableConhecimento.unselect($event)" (p-all-selected)="tableConhecimento.selectAll($event)"
          (p-all-unselected)="tableConhecimento.unselectAll($event)">
        </po-table>
      </po-step>
      <po-step p-label="Finalizado">
        <div class="po-row">
          <h3 class="mensagem-centralizada">
            Nota Fiscal de número {{stepper.numeroNota}} incluída com sucesso!
          </h3>
        </div>
      </po-step>
    </po-stepper>
  </ng-template>

  <ng-template [ngIf]="!isAddPage">
    <!-- <div class="po-row"> -->
    <div *ngFor="let d of arrHeaders">
      <po-input *ngIf="d.type == 'C' && !d.select && !d.f3 && d.property != 'F1_XREJEIC' && d.property != 'F1_DOC'"
        class="po-md-3" p-label="{{d.label}}" [p-disabled]="disabledField" p-maxlength="{{d.tamanho}}"
        p-required="{{d.required}}" p-readonly="{{d.readonly}}" [(ngModel)]="dados[d.property]"
        p-mask="{{d.format}}"></po-input>
      <po-number *ngIf="d.property == 'F1_DOC'" class="po-md-3" p-min="1" p-max="999999999" p-label="{{d.label}}"
        [p-disabled]="disabledField" p-maxlength="{{d.tamanho}}" p-required="{{d.required}}" p-readonly="{{d.readonly}}"
        [(ngModel)]="dados[d.property]"></po-number>
      <po-input *ngIf="d.property == 'F1_COND'" class="po-md-3" p-label="{{d.label}}" p-disabled="true"
        p-maxlength="{{d.tamanho}}" p-required="{{d.required}}" p-readonly="{{d.readonly}}"
        [(ngModel)]="dados[d.property]" p-mask="{{d.format}}"></po-input>
      <po-input *ngIf="d.property == 'F1_XREJEIC'" class="po-md-8" p-label="{{d.label}}" p-disabled="true"
        p-maxlength="{{d.tamanho}}" p-required="{{d.required}}" p-readonly="{{d.readonly}}"
        [(ngModel)]="dados[d.property]" p-mask="{{d.format}}"></po-input>

      <po-select *ngIf="d.select   && d.property != 'F1_SERIE'" class="po-md-4" p-label="{{d.label}}"
        [p-disabled]="disabledFieldEdit" p-required="{{d.required}}" p-readonly="{{d.readonly}}" [p-options]="d.options"
        [(ngModel)]="dados[d.property]"></po-select>

      <po-select *ngIf="d.property == 'F1_SERIE'" class="po-md-3" p-label="{{d.label}}" [p-disabled]="disabledFieldEdit"
        p-required="{{d.required}}" p-readonly="{{d.readonly}}" [p-options]="d.options" [(ngModel)]="dados[d.property]"
        (click)="abrirMensagemGov()"></po-select>

      <po-datepicker *ngIf="d.type == 'D'" class="po-md-3" p-label="{{d.label}}" [p-disabled]="disabledFieldEdit"
        p-required="{{d.required}}" p-readonly="{{d.readonly}}" [(ngModel)]="dados[d.property]"></po-datepicker>
      <!-- <po-datepicker *ngIf="d.type == 'D'" class="po-md-4" p-label="{{d.label}}" [p-disabled]="disabledField || disabledFieldEdit" p-required="{{d.required}}" p-readonly="{{d.readonly}}" [(ngModel)]="dados[d.property]"></po-datepicker> -->
      <po-number *ngIf="d.type == 'N'" class="po-md-4" p-label="{{d.label}}" [p-disabled]="disabledFieldEdit"
        p-required="{{d.required}}" p-readonly="{{d.readonly}}" [(ngModel)]="dados[d.property]"></po-number>
      <po-textarea *ngIf="d.type == 'M'" class="po-md-4" p-label="{{d.label}}" [p-disabled]="disabledFieldEdit"
        p-required="{{d.required}}" p-readonly="{{d.readonly}}" [(ngModel)]="dados[d.property]"></po-textarea>
      <po-combo class="po-lg-4" p-label="{{d.label}}" [p-options]="selects.especieDocumento" p-filter-mode="contains"
        [p-disabled]="disabledFieldEdit" p-required="{{d.required}}" [(ngModel)]="dados[d.property]"
        *ngIf="d.f3 && d.tabela == '42'"></po-combo>
    </div>
    <!-- </div> -->

    <!-- *ngIf="arrHeaders.length <= 0" -->
    <po-divider class="po-md-12" p-label="Itens da Nota Fiscal"></po-divider>

    <table class="table text-center po-table-main-container po-table">
      <thead>
        <tr>
          <th class="po-table-header">Item </th>
          <th class="po-table-header">Código</th>
          <th class="po-table-header">Quantidade</th>
          <th class="po-table-header">Valor Unitário</th>
          <th class="po-table-header">Valor Total</th>
          <th class="po-table-header">Pedido</th>
          <th class="po-table-header">Item Pedido </th>
          <th class="po-table-header">Histórico</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of tableItens" class="altura-linha">
          <td style="font-weight: bold;" class="po-table-column po-table-striped">
            <po-info class="po-lg-12" [p-value]="item.D1_ITEM"></po-info>
          </td>
          <td class="po-table-column po-table-striped">
            <po-info style="font-weight: bold;" class="po-lg-12" [p-value]="item.D1_COD"> </po-info>
          </td>
          <td class="po-table-column po-table-striped">
            <po-decimal [p-disabled]="disabledField" class="po-lg-12" p-clean="true"
              (p-change)="calculaPrecoAplicado(item)" [(ngModel)]="item.D1_QUANT"></po-decimal>
          </td>
          <td class="po-table-column po-table-striped">
            <po-decimal class="po-lg-12" p-disabled="true" p-decimals-length="2"
              [(ngModel)]="item.D1_VUNIT"></po-decimal>
          </td>
          <td class="po-table-column po-table-striped">
            <po-decimal class="po-lg-12" p-disabled="true" p-decimals-length="2"
              [(ngModel)]="item.D1_TOTAL"></po-decimal>
          </td>
          <td class="po-table-column po-table-striped">
            <po-input class="po-lg-12" p-disabled="true" [(ngModel)]="item.D1_PEDIDO"></po-input>
          </td>

          <td class="po-table-column po-table-striped">
            <po-input class="po-lg-12" p-disabled="true" [(ngModel)]="item.D1_ITEMPC"></po-input>
          </td>
          <td class="po-table-column po-table-striped">
            <po-textarea p-disabled="true" [(ngModel)]='item.D1_XHISTOR'> </po-textarea>
          </td>
        </tr>
      </tbody>
    </table>
  </ng-template>
  <po-loading-overlay *ngIf="loading" p-screen-lock="true" p-text="Carregando">
  </po-loading-overlay>
</po-page-default>

<!-- Mudal utilizado para incluir item -->

<po-modal #modalInserirItem p-hide-close="false" p-click-out="false" p-title="Inserir Item"
  [p-primary-action]="confirmItem" [p-secondary-action]="cancelItem" p-size="xl">

  <div class="po-row">
    <po-table [p-columns]="tableModal.columns" [p-items]="tableModal.items" p-sort="true" p-striped="true"
      p-hide-text-overflow="true" [p-height]="tableModal.height" p-selectable="true" p-single-select="false"
      (p-selected)="selected($event)" (p-unselected)="unSelected($event)" (p-all-selected)="allSelected($event)"
      (p-all-unselected)="unAllSelected($event)">
    </po-table>
  </div>

</po-modal>

<!-- Mudal utilizado para incluir pedido -->

<po-modal #modalInserirPedido p-hide-close="false" p-click-out="false" p-title="Inserir Pedido"
  [p-primary-action]="confirmPedido" [p-secondary-action]="cancelPedido" p-size="xl">
  <div class="po-row">
    <po-table [p-columns]="tableModal.columns" [p-items]="tableModal.items" p-sort="true" p-striped="true"
      p-hide-text-overflow="true" [p-height]="tableModal.height" p-selectable="true" p-single-select="false"
      (p-selected)="selected($event)" (p-unselected)="unSelected($event)" (p-all-selected)="allSelected($event)"
      (p-all-unselected)="unAllSelected($event)">
    </po-table>
  </div>
</po-modal>

<po-modal #emailModal [p-primary-action]="emailModalPrimaryAction" [p-secondary-action]="emailModalSecondaryAction">
  <form [formGroup]="emailForm">
    <po-input formControlName="to" [p-disabled]="true"></po-input>
    <po-textarea formControlName="message"></po-textarea>
  </form>
</po-modal>

<po-modal #modalVerificarPedido p-hide-close="false" p-click-out="false" p-title="Atenção!" p-size="xl">
  <div class="po-row">
    <h3 class="mensagem-alerta">Verifique se o pedido está de acordo com o valor de sua nota, caso contrário, favor
      entrar em contato com a área solicitante.</h3>
  </div>
</po-modal>
<po-modal #mensagemGov2 p-title="Atenção">
  <div class="modal-alert">
    <span class="alert-triangle"></span>

    <h3>
      Informamos que, a partir de fevereiro/2026, haverá a mudança da série
      de RFB/UNI para GOV no portal de fornecedores.
    </h3>

  </div>
</po-modal>